import FormLayout from '../../../layout/FormLayout/FormLayout';
import FormWrapper from '../../../layout/FormWrapper/FormWrapper';
import FormCollapsableRow from '../../../layout/FormCollapsableRow/FormCollapsableRow';
import Input from '../../../../../components/Input/Input';
import SelectedValuesList from '../../../../../components/SelectedValuesList/SelectedValuesList';

const StorageViewServiceProvider = ({ selectedData, onClose }: any) => {
    return (
        <FormWrapper mode={'view'}>
            <FormLayout
                title={'Service providers'}
                description={'Here are the service providerss.'}
                onClose={onClose}
                useContentPadding={false}
                useSeparatorMargin={false}
            >
                <FormCollapsableRow
                    disabled={true}
                    titleLabel={'0. Inherited service provider(s) from another structure'}
                />

                {selectedData.map((item: any, index: number) => (
                    <FormCollapsableRow
                        key={index}
                        titleLabel={`${index + 1}. service provider`}
                        titleValue={`${item.role} :: ${item.counterparty}`}
                    >
                        <Input readOnly value={item.role}>
                            Role
                        </Input>

                        <Input readOnly value={'Counterparty'} disabled>
                            Agreement
                        </Input>

                        <Input readOnly value={item.counterparty} margin={false}>
                            Name
                        </Input>

                        <Input readOnly value={item.regulationFullName} margin={false}>
                            Regulatory status
                        </Input>
                    </FormCollapsableRow>
                ))}
            </FormLayout>
        </FormWrapper>
    );
};

export default StorageViewServiceProvider;
